/**
 * Helper function to enable onboarding test mode from browser console
 *
 * Usage:
 * 1. Open browser console
 * 2. Run: window.enableOnboardingTestMode()
 * 3. Refresh the page
 */

import { setOnboardingTestMode } from '../../Redux/actions/onboardingActions';
import store from '../../Redux/store';

export const enableOnboardingTestMode = () => {
  store.dispatch(setOnboardingTestMode(true));
};

export const disableOnboardingTestMode = () => {
  store.dispatch(setOnboardingTestMode(false));
};

// Expose to window for easy console access
if (typeof window !== 'undefined') {
  (window as any).enableOnboardingTestMode = enableOnboardingTestMode;
  (window as any).disableOnboardingTestMode = disableOnboardingTestMode;
}
